import { useState } from "react";
import { api } from "@/lib/api";
import { formatApiError } from "@/context/AuthContext";
import { ArrowRight } from "lucide-react";

export default function DropListForm({
  source = "homepage_drop_list",
  productSlug = null,
  testIdPrefix = "drop-list",
  placeholder = "Terminal address (email)",
  submitLabel = "Authorize",
}) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });

  async function onSubmit(e) {
    e.preventDefault();
    if (!email) return;
    setState({ status: "loading", message: "" });
    try {
      const payload = {
        email,
        source,
        page_url: typeof window !== "undefined" ? window.location.href : null,
      };
      if (productSlug) payload.product_slug = productSlug;
      const { data } = await api.post("/drop-list", payload);
      setState({ status: "success", message: data.message || "UPLINK LOGGED." });
      setEmail("");
    } catch (err) {
      setState({
        status: "error",
        message:
          formatApiError(err.response?.data?.detail) ||
          "Could not save your email. Try again.",
      });
    }
  }

  return (
    <form onSubmit={onSubmit} data-testid={`${testIdPrefix}-form`} className="flex flex-col gap-3">
      <div className="flex flex-col sm:flex-row gap-0 sm:gap-0">
        <input
          data-testid={`${testIdPrefix}-email`}
          type="email"
          name="email"
          autoComplete="email"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          inputMode="email"
          enterKeyHint="send"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={placeholder}
          className="field sm:flex-1 sm:border-r-0"
        />
        <button
          data-testid={`${testIdPrefix}-submit`}
          type="submit"
          disabled={state.status === "loading"}
          className="btn-primary justify-center sm:w-auto"
        >
          {state.status === "loading" ? "Sending…" : submitLabel}
          <ArrowRight size={14} strokeWidth={1.5} />
        </button>
      </div>
      {state.message && (
        <p
          data-testid={`${testIdPrefix}-message`}
          className={`font-mono text-[11px] tracking-[0.18em] uppercase ${
            state.status === "success" ? "text-[#00ff41]" : "text-[#ff3b30]"
          }`}
        >
          // {state.message}
        </p>
      )}
    </form>
  );
}
